export default __webpack_public_path__ + "static/custom-tooltips-2b0e40f5252e9f98d016d34be98bb0f0.png";